module.exports = __webpack_public_path__ + "img/photo-of-deep-sky-object-816608.61e9f3a3.jpg";